import { compose } from 'redux';
import { connect } from 'react-redux';

import routeDependencies from 'utilities/routeDependencies';
import { loadable } from 'modules/layout';

import NewsPage from '../components/NewsPage';

import { newsDetailRequest } from '../services/actions';
import { selectDetailPending } from '../services/selectors';

export default compose(
    connect(
        (state, { match: { params } }) => ({
            id: params.id,
            showLoader: selectDetailPending(state, {}),
        }),
        dispatch => ({
            read: (id, delayed) => {
                dispatch(newsDetailRequest({ id, delayed }));
            },
        }),
    ),
    routeDependencies({
        onRouteEnter: ({ match: { params }, delayed, read }) => {
            read(params.id, delayed);
        },
    }),
    loadable,
)(NewsPage);
